import { render } from "./AdminTerminationRequests.vue?vue&type=template&id=e43f813c&scoped=true"
import script from "./AdminTerminationRequests.vue?vue&type=script&lang=js"
export * from "./AdminTerminationRequests.vue?vue&type=script&lang=js"

import "./AdminTerminationRequests.vue?vue&type=style&index=0&id=e43f813c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e43f813c"]])

export default __exports__